export function setLocalStorageItem<T extends keyof LocalStorageItems>(
  key: T,
  value: LocalStorageItems[T],
) {
  if (typeof window === 'undefined') return;
  localStorage.setItem(key, JSON.stringify(value));
}
